import { Content, ContentVariants } from '@patternfly/react-core';
import React from 'react';

export default function PageBodyContent() {
  return (
    <div>
      <Content component={ContentVariants.p}>
        Cupcake ipsum dolor sit amet pie sugar plum. Candy canes toffee chocolate cake halvah bonbon icing. Cookie wafer
        topping jelly-o I love cookie jujubes lemon drops. Dragée pudding pastry ice cream chocolate. Fruitcake icing
        cheesecake danish sesame snaps shortbread bear claw toffee. Gingerbread pudding brownie soufflé bonbon tiramisu
        I love tootsie roll dragée.
      </Content>
      <Content component={ContentVariants.p}>
        Soufflé tart I love oat cake gummies chocolate. Dessert jelly icing apple pie gummi bears pudding. Lollipop
        halvah carrot cake carrot cake powder soufflé. Donut tootsie roll chocolate I love topping danish. Jujubes
        shortbread topping powder soufflé cake liquorice. Jelly beans chocolate cake liquorice dragée donut tootsie roll
        jujubes ice cream brownie. Carrot cake cake chupa chups cheesecake I love powder candy canes cotton candy
        croissant. Bear claw lollipop jujubes bear claw apple pie.
      </Content>
      <Content component={ContentVariants.p}>
        Soufflé dessert cookie I love topping. Soufflé jelly beans macaroon liquorice sesame snaps sweet roll. Apple pie
        oat cake cotton candy cookie chupa chups. Marzipan gummi bears cupcake caramels I love cookie. Cake shortbread
        jelly-o chocolate candy canes bonbon cookie. Sweet roll I love danish wafer gummi bears.
      </Content>
      <Content component={ContentVariants.p}>
        Jelly-o topping oat cake cotton candy carrot cake carrot cake chocolate cake cookie. Dragée topping chocolate
        cake cupcake marzipan jujubes tiramisu. Candy soufflé dragée toffee croissant marshmallow. Caramels caramels I
        love marshmallow bonbon cake wafer chupa chups caramels. Sweet roll jelly bear claw I love pastry ice cream.
        Dessert marzipan caramels topping topping liquorice cupcake liquorice. Cookie toffee candy canes liquorice
        tootsie roll. I love cookie marshmallow cotton candy chocolate cake.
      </Content>
      <Content component={ContentVariants.p}>
        Lemon drops powder topping danish macaroon jujubes. Tart bear claw tootsie roll macaroon croissant jelly beans
        chocolate bar. I love fruitcake apple pie marshmallow pie powder candy bear claw. Shortbread pie oat cake pastry
        powder. Gingerbread gingerbread ice cream I love gummi bears. Bear claw jelly-o tart biscuit topping.
        Gingerbread lollipop tiramisu chupa chups gummies cheesecake gingerbread. Jelly-o I love gummi bears sesame
        snaps candy canes pie gummi bears donut. Liquorice tiramisu cake I love jelly candy canes jujubes chocolate.
      </Content>
      <Content component={ContentVariants.p}>
        Cupcake ipsum dolor sit amet pie sugar plum. Candy canes toffee chocolate cake halvah bonbon icing. Cookie wafer
        topping jelly-o I love cookie jujubes lemon drops. Dragée pudding pastry ice cream chocolate. Fruitcake icing
        cheesecake danish sesame snaps shortbread bear claw toffee. Gingerbread pudding brownie soufflé bonbon tiramisu
        I love tootsie roll dragée.
      </Content>
      <Content component={ContentVariants.p}>
        Soufflé tart I love oat cake gummies chocolate. Dessert jelly icing apple pie gummi bears pudding. Lollipop
        halvah carrot cake carrot cake powder soufflé. Donut tootsie roll chocolate I love topping danish. Jujubes
        shortbread topping powder soufflé cake liquorice. Jelly beans chocolate cake liquorice dragée donut tootsie roll
        jujubes ice cream brownie. Carrot cake cake chupa chups cheesecake I love powder candy canes cotton candy
        croissant. Bear claw lollipop jujubes bear claw apple pie.
      </Content>
      <Content component={ContentVariants.p}>
        Soufflé dessert cookie I love topping. Soufflé jelly beans macaroon liquorice sesame snaps sweet roll. Apple pie
        oat cake cotton candy cookie chupa chups. Marzipan gummi bears cupcake caramels I love cookie. Cake shortbread
        jelly-o chocolate candy canes bonbon cookie. Sweet roll I love danish wafer gummi bears.
      </Content>
      <Content component={ContentVariants.p}>
        Jelly-o topping oat cake cotton candy carrot cake carrot cake chocolate cake cookie. Dragée topping chocolate
        cake cupcake marzipan jujubes tiramisu. Candy soufflé dragée toffee croissant marshmallow. Caramels caramels I
        love marshmallow bonbon cake wafer chupa chups caramels. Sweet roll jelly bear claw I love pastry ice cream.
        Dessert marzipan caramels topping topping liquorice cupcake liquorice. Cookie toffee candy canes liquorice
        tootsie roll. I love cookie marshmallow cotton candy chocolate cake.
      </Content>
      <Content component={ContentVariants.p}>
        Lemon drops powder topping danish macaroon jujubes. Tart bear claw tootsie roll macaroon croissant jelly beans
        chocolate bar. I love fruitcake apple pie marshmallow pie powder candy bear claw. Shortbread pie oat cake pastry
        powder. Gingerbread gingerbread ice cream I love gummi bears. Bear claw jelly-o tart biscuit topping.
        Gingerbread lollipop tiramisu chupa chups gummies cheesecake gingerbread. Jelly-o I love gummi bears sesame
        snaps candy canes pie gummi bears donut. Liquorice tiramisu cake I love jelly candy canes jujubes chocolate.
      </Content>
      <Content component={ContentVariants.p}>
        Cupcake ipsum dolor sit amet pie sugar plum. Candy canes toffee chocolate cake halvah bonbon icing. Cookie wafer
        topping jelly-o I love cookie jujubes lemon drops. Dragée pudding pastry ice cream chocolate. Fruitcake icing
        cheesecake danish sesame snaps shortbread bear claw toffee. Gingerbread pudding brownie soufflé bonbon tiramisu
        I love tootsie roll dragée.
      </Content>
      <Content component={ContentVariants.p}>
        Soufflé tart I love oat cake gummies chocolate. Dessert jelly icing apple pie gummi bears pudding. Lollipop
        halvah carrot cake carrot cake powder soufflé. Donut tootsie roll chocolate I love topping danish. Jujubes
        shortbread topping powder soufflé cake liquorice. Jelly beans chocolate cake liquorice dragée donut tootsie roll
        jujubes ice cream brownie. Carrot cake cake chupa chups cheesecake I love powder candy canes cotton candy
        croissant. Bear claw lollipop jujubes bear claw apple pie.
      </Content>
      <Content component={ContentVariants.p}>
        Soufflé dessert cookie I love topping. Soufflé jelly beans macaroon liquorice sesame snaps sweet roll. Apple pie
        oat cake cotton candy cookie chupa chups. Marzipan gummi bears cupcake caramels I love cookie. Cake shortbread
        jelly-o chocolate candy canes bonbon cookie. Sweet roll I love danish wafer gummi bears.
      </Content>
      <Content component={ContentVariants.p}>
        Jelly-o topping oat cake cotton candy carrot cake carrot cake chocolate cake cookie. Dragée topping chocolate
        cake cupcake marzipan jujubes tiramisu. Candy soufflé dragée toffee croissant marshmallow. Caramels caramels I
        love marshmallow bonbon cake wafer chupa chups caramels. Sweet roll jelly bear claw I love pastry ice cream.
        Dessert marzipan caramels topping topping liquorice cupcake liquorice. Cookie toffee candy canes liquorice
        tootsie roll. I love cookie marshmallow cotton candy chocolate cake.
      </Content>
      <Content component={ContentVariants.p}>
        Lemon drops powder topping danish macaroon jujubes. Tart bear claw tootsie roll macaroon croissant jelly beans
        chocolate bar. I love fruitcake apple pie marshmallow pie powder candy bear claw. Shortbread pie oat cake pastry
        powder. Gingerbread gingerbread ice cream I love gummi bears. Bear claw jelly-o tart biscuit topping.
        Gingerbread lollipop tiramisu chupa chups gummies cheesecake gingerbread. Jelly-o I love gummi bears sesame
        snaps candy canes pie gummi bears donut. Liquorice tiramisu cake I love jelly candy canes jujubes chocolate.
      </Content>
    </div>
  );
}
